<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="true"
                :showAddNew="true"
                :title="'POS Invoice'"
                btnTitle="New Bill"
                @onClickCloseButton="closeButton"
            />
        </div>
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class="chat-fixed-search p-2">
                    <div class="d-flex align-items-center w-100">
                        <div class="input-group input-group-merge ms-1 w-100">
                            <div class="col-md-8 py-1">
                                <input v-model="searchId" type="text" class="form-control round"
                                    id="chat-search"
                                    placeholder="Search By Id" aria-label="Search..."
                                    aria-describedby="chat-search"
                                    :onchange="addItemById"
                                />
                            </div>
                            
                            <div class="col-md-8 py-1">
                                <AsyncSelect
                                    placeholder="Select Product"
                                    v-model="productId"
                                    label="text"
                                    :api-service="fetchProducts"
                                    :reduce="name => name.id"
                                    :additional-query="additionalProductQuery"
                                    ref="productField"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 py-2 ">
                <div class="py-1 px-2 px-md-0">
                    <div class="d-flex align-items-center">
                        <div class="col-8">
                            <v-select
                                placeholder="Select Customer"
                                v-model="contactProfileId"
                                :options="contacts"
                                label="name"
                                :reduce="name => name.id"
                            />
                        </div>

                        <div class="mx-auto">
                            <button class="btn btn-primary btn-sm font-24"  @click="openCustomerAddModal">
                                +
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row justify-content-end">
                <div class="col-md-6 mb-2">
                    <v-select
                        placeholder="Shop/Location Name"
                        v-model="locationId"
                        :options="locations"
                        label="text"
                        :reduce="text => text.id"
                    />
                </div>
            </div>

            <AddCustomerModal
                v-if="$store.state.isModalOpenTwo"
                @onCreateProfile="onCreateProfile"
            />
            
            <ItemCard v-if="!loader"
                :items="productList"
                :contactProfileId="contactProfileId"
                :companyId="companyId"
                :locationId="locationId"
                :productId="productId"
                @resetIds="handleResetIds"
            />

            <Loader v-if="loader"/>
        </div>
    </div>
</template>

<script setup>
    import TitleButton from '@/components/atom/TitleButtonHospital';
    import ItemCard from '@/components/molecule/company/hospital/PosInvoiceItemCard.vue';
    import handleInventory from '@/services/modules/inventory';
    import Loader from '@/components/atom/LoaderComponent'
    import { onMounted, ref, computed } from 'vue';
    import {useRoute, useRouter} from 'vue-router';
    import handleContact from '@/services/modules/contact'
    import handleBusinessesLocations from '@/services/modules/businessesLocations';
    import handlePurchase from "@/services/modules/purchase";
    import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
    import AddCustomerModal from "@/components/molecule/company/inventory/AddCustomerModal.vue";
    import { useStore } from 'vuex';

    const $route = useRoute();
    const $router = useRouter();
    const $store = useStore();

    const productList = ref([]);
    const loader = ref(true);
    const contactProfileId = ref(null);
    const companyId = $route.params.companyId
    const companyQuery = `?company_id=${companyId}`
    const contacts = ref([]);
    const locations = ref([]);
    const locationId = ref(null);
    const productId = ref(null);
    const searchId = ref(null);

    const { fetchProducts } = handlePurchase();
    const { fetchProductList } = handleInventory();
    const {fetchContactProfiles} = handleContact();
    const {fetchBusinessLocationsList} = handleBusinessesLocations();
    const businessLocationRes = fetchBusinessLocationsList(companyQuery)

    onMounted(()=>{
        getItems();
        getContacts();
        businessLocationRes.then(res=> {
            if(res.data) {
                locations.value = res.data
                locationId.value = locations.value[0].id;
            }
        });
    })

    const getContacts = async () => {
        try{
            const res = await fetchContactProfiles(companyQuery);
            if(res.data){
                contacts.value = res.data;
            }
        }catch(e){
            console.log('Something went wrong');
        }
    }

    const getItems = async () => {
        const query = `?company_id=${companyId}&product_type=finished_goods`
        try{
            const { data } = await fetchProductList(query);
            if(data.length == 0){
                return
            }
            productList.value = data 
        }catch(e){
            console.log("Something went wrong");
        }
        loader.value = false
    }

    const handleResetIds = () => {
        locationId.value = locations.value[0].id;
        productId.value = null;
        searchId.value = null;
    }

    const closeButton = () => {
        $router.push({name: 'invoice-electronics-list',
            params: {
                companyId: $route.params.companyId,
                moduleId: $route.params.moduleId,
                menuId: $route.params.menuId,
                pageId: $route.params.pageId
            },
            query: {
                start: $route.query.start,
                end: $route.query.end
            }
        })
    }

    const addItemById = () => {
        productId.value = searchId.value;
    }

    const additionalProductQuery = computed(() => {
        return {
            location_id: locationId.value,
            product_type: 'finished_goods'
        }
    })

    const openCustomerAddModal = () => {
        $store.state.isModalOpenTwo = true
    }

    const onCreateProfile = (profileInfo) => {
        contactProfileId.value = profileInfo.id
        getContacts();
    }
</script>

<style scoped>
.font-24 {
    font-size: 24px;
}
</style>